/**
 * Pure helpers for the self-cancel feature (no I/O) — ТЗ §11.
 */

/** Format a countdown in seconds as ``м:сс`` (e.g. 300 → "5:00", 9 → "0:09"). */
export function formatCountdown(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}
